import { CommonKeys } from "../../common/enums";
// eslint-disable-next-line max-len
import { BERICHT_BILD_TYPE, BERICHT_TEXT_TYPE, FORMULAR_GROUP_BERICHTE_TYPE, FORMULAR_GROUP_WARTUNGEN_TYPE, WARTUNG_BERICHTE_TYPE, WARTUNG_ELEMENT_TYPE, WARTUNG_TYPE, WARTUNGEN_ELEMENTE_TYPE, WARTUNGEN_TYPE } from "../../common/formular-group-types";

export const FormularGroupWartungenSchema = {
    $id: "FormularGroupWartungenSchema",
    title: "FormularGroupWartungen Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_WARTUNGEN_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string" },
        [CommonKeys.ShowLabel]: { type: "boolean" },
        Wartungen: {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: WARTUNGEN_TYPE },
                [CommonKeys.Values]: {
                    type: "array",
                    items: { $ref: "FormularGroupWartungenWartungenWartungSchema" }
                }
            }
        }
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, "Wartungen"]
};

const FormularGroupWartungenWartungenWartungSchema = {
    $id: "FormularGroupWartungenWartungenWartungSchema",
    title: "FormularGroupWartungenWartungenWartung Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: WARTUNG_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string" },
    },
    anyOf: [
        {
            properties: {
                Elemente: { $ref: "FormularGroupWartungenWartungenElementeSchema" }
            },
            required: ["Elemente"]
        },
        {
            properties: {
                Berichte: { $ref: "FormularGroupWartungenWartungenBerichteSchema" }
            },
            required: ["Berichte"]
        }
    ],
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label]
}

const FormularGroupWartungenWartungenElementeSchema = {
    $id: "FormularGroupWartungenWartungenElementeSchema",
    title: "FormularGroupWartungenWartungenElemente Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: WARTUNGEN_ELEMENTE_TYPE },
        [CommonKeys.Values]: {
            type: "array",
            items: { $ref: "FormularGroupWartungenWartungenElementSchema" }
        }
    }
}

const FormularGroupWartungenWartungenElementSchema = {
    $id: "FormularGroupWartungenWartungenElementSchema",
    title: "FormularGroupWartungenWartungenElement Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: WARTUNG_ELEMENT_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string" },
        State: { type: "number" }
    },
    required: [CommonKeys.Type, CommonKeys.ID, CommonKeys.Label, "State"]
}


const FormularGroupWartungenWartungenBerichteSchema = {
    $id: "FormularGroupWartungenWartungenBerichteSchema",
    title: "FormularGroupWartungenWartungenBerichte Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_GROUP_BERICHTE_TYPE },
        [CommonKeys.ID]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        [CommonKeys.ShowLabel]: { type: "boolean", nullable: true },
        Berichte: {
            type: "object",
            properties: {
                [CommonKeys.Type]: { const: WARTUNG_BERICHTE_TYPE },
                [CommonKeys.Values]: {
                    type: "array",
                    items: {
                        oneOf: [
                            { $ref: "FormularGroupWartungenWartungenBerichtTextSchema" },
                            { $ref: "FormularGroupWartungenWartungenBerichtBildSchema" }
                        ]
                    }
                }
            }
        }
    }
}

const FormularGroupWartungenWartungenBerichtTextSchema = {
    $id: "FormularGroupWartungenWartungenBerichtTextSchema",
    title: "FormularGroupWartungenWartungenBerichtTex Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: BERICHT_TEXT_TYPE },
        [CommonKeys.Value]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true }
    },
    required: [CommonKeys.Type, CommonKeys.Value, CommonKeys.Label]
}

const FormularGroupWartungenWartungenBerichtBildSchema = {
    $id: "FormularGroupWartungenWartungenBerichtBildSchema",
    title: "FormularGroupWartungenWartungenBerichtBild Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: BERICHT_BILD_TYPE },
        [CommonKeys.Value]: { type: "string", nullable: true },
        [CommonKeys.Label]: { type: "string", nullable: true },
        ImageID: { type: "string" }
    },
    required: [CommonKeys.Type, CommonKeys.Value, CommonKeys.Label, "ImageID"]
}

export const FORMULAR_GROUP_WARTUNGEN_SCHEMAS = [
    FormularGroupWartungenSchema,
    FormularGroupWartungenWartungenWartungSchema,
    FormularGroupWartungenWartungenElementeSchema,
    FormularGroupWartungenWartungenElementSchema,
    FormularGroupWartungenWartungenBerichteSchema,
    FormularGroupWartungenWartungenBerichtTextSchema,
    FormularGroupWartungenWartungenBerichtBildSchema
]